/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_DescriptionInputs */

const en_gc_resources_download_description = /** @type {(inputs: Gc_Resources_Download_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a GridCraft download for Windows, macOS or Linux below. These links point to the official ArtCraft project’s v0.7.0 GitHub release. Match the package to your operating system and processor; other architectures are listed on the releases page. Read the release notes before updating, and keep an original copy of each important workbook.`)
};

const zh_gc_resources_download_description = /** @type {(inputs: Gc_Resources_Download_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在下方获取 Windows、macOS 或 Linux 版 GridCraft。链接指向 ArtCraft 官方项目的 v0.7.0 GitHub 发布页。请选择符合系统与处理器的版本，其他架构见发布页。更新前阅读说明，并保留重要工作簿的原始副本。`)
};

/**
* | output |
* | --- |
* | "Find a GridCraft download for Windows, macOS or Linux below. These links point to the official ArtCraft project’s v0.7.0 GitHub release. Match the package to..." |
*
* @param {Gc_Resources_Download_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_description = /** @type {((inputs?: Gc_Resources_Download_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_description(inputs)
	return zh_gc_resources_download_description(inputs)
});
export { gc_resources_download_description as "gc.resources.download.description" }